import React, { lazy } from 'react';

const ControlPanelPage: React.ComponentType<any> = lazy(() => import('../../pages/ControlPanelPage'));
const PricingPage: React.ComponentType<any> = lazy(() => import('../../pages/PricingPage'));
const UsersPage: React.ComponentType<any> = lazy(() => import('../../pages/UsersPage'));
const AuditLogPage: React.ComponentType<any> = lazy(() => import('../../pages/AuditLogPage'));
const ClientsPage: React.ComponentType<any> = lazy(() => import('../../pages/ClientsPage'));
const ReceivablesPage: React.ComponentType<any> = lazy(() => import('../../pages/ReceivablesPage'));
const AIModelsPage: React.ComponentType<any> = lazy(() => import('../../pages/AIModelsPage'));
const ComponentLibraryPage: React.ComponentType<any> = lazy(() => import('../../pages/ComponentLibraryPage'));
const QmLibraryPage: React.ComponentType<any> = lazy(() => import('../../pages/QmLibraryPage'));
const QuotePriceListPage: React.ComponentType<any> = lazy(() => import('../../pages/quote-price-list/QuotePriceListPage'));
const QuoteBrainReportPage: React.ComponentType<any> = lazy(() => import('../../pages/QuoteBrainReportPage'));

export interface AppSecondaryPagesRouterProps {
    currentPage: string;
    handleNavigate: (page: string, options?: any) => void;
    pageNavOptions?: any;
    showConfirm?: any;
    apiKey?: string;
    model?: string;
    audioModel?: string;
    user?: any;
    projects?: any[];
    /** False while App's project list is still loading (Clients shows loading, not empty). */
    projectsLoaded?: boolean;
    clientRefreshTrigger?: number;
    onRefreshProjects?: () => Promise<unknown>;
    receivablesDisabled?: boolean;
    openProjectFromList?: (project: any) => void;
}

export const AppSecondaryPagesRouter: React.FC<AppSecondaryPagesRouterProps> = ({
    currentPage,
    handleNavigate,
    pageNavOptions,
    showConfirm,
    apiKey,
    model,
    audioModel,
    user,
    projects = [],
    projectsLoaded = true,
    clientRefreshTrigger,
    onRefreshProjects,
    receivablesDisabled,
    openProjectFromList,
}) => {
    if (currentPage === 'estate') {
        return <ControlPanelPage />;
    }
    if (currentPage === 'business-training') {
        return <PricingPage onNavigate={handleNavigate} onOpenProject={openProjectFromList} pageNavOptions={pageNavOptions} showConfirm={showConfirm} />;
    }
    if (currentPage === 'users') {
        return <UsersPage onNavigate={handleNavigate} showConfirm={showConfirm} user={user} />;
    }
    if (currentPage === 'audit') {
        return <AuditLogPage onNavigate={handleNavigate} />;
    }
    if (currentPage === 'clients') {
        return <ClientsPage projects={projects} projectsLoaded={projectsLoaded} onNavigate={handleNavigate} onRefreshProjects={onRefreshProjects} refreshTrigger={clientRefreshTrigger} pageNavOptions={pageNavOptions} />;
    }
    if (currentPage === 'receivables' && !receivablesDisabled) {
        return (
            <ReceivablesPage
                onNavigate={handleNavigate}
                projects={projects}
                onOpenProject={openProjectFromList}
                showConfirm={showConfirm}
            />
        );
    }
    if (currentPage === 'aimodels') {
        return <AIModelsPage onNavigate={handleNavigate} apiKey={apiKey} model={model} audioModel={audioModel} />;
    }
    if (currentPage === 'component-library') {
        return <ComponentLibraryPage onNavigate={handleNavigate} />;
    }
    if (currentPage === 'qm-library') {
        return <QmLibraryPage onNavigate={handleNavigate} />;
    }
    if (currentPage === 'quote-price-list') {
        return <QuotePriceListPage onNavigate={handleNavigate} />;
    }
    if (currentPage === 'quote-brain-report') {
        return <QuoteBrainReportPage />;
    }
    return null;
};

export default AppSecondaryPagesRouter;
